module.exports = __webpack_public_path__ + "img/421.b63107c3.jpg";